import { render, staticRenderFns } from "./PermissionForm.vue?vue&type=template&id=e2756c6e&scoped=true&"
import script from "./PermissionForm.vue?vue&type=script&lang=js&"
export * from "./PermissionForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionForm.vue?vue&type=style&index=0&id=e2756c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2756c6e",
  null
  
)

export default component.exports